"use strict";

/**
 * State object
 */
const initialState = () => ({
  // Authentication dialogs
  authLoginDialog: false,
  authVolunteerRegisterDialog: false,
  authEntityRegisterDialog: false,
  changePasswordDialog: false,

  // Loader
  loading: false
});
const state = initialState();

// Getter functions
const getters = {
  // Authentication dialogs
  getAuthLoginDialog: state => state.authLoginDialog,
  getAuthVolunteerRegisterDialog: state => state.authVolunteerRegisterDialog,
  getAuthEntityRegisterDialog: state => state.authEntityRegisterDialog,
  getChangePasswordDialog: state => state.changePasswordDialog,

  // Loader
  isLoading: state => state.loading
};

// Actions
const actions = {
  // Authentication login dialog
  showAuthLoginDialog({ commit }) {
    commit("setAuthLoginDialog", true);
  },
  hideAuthLoginDialog({ commit }) {
    commit("setAuthLoginDialog", false);
  },

  // Authentication volunteer register dialog
  showAuthVolunteerRegisterDialog({ commit }) {
    commit("setAuthVolunteerRegisterDialog", true);
  },
  hideAuthVolunteerRegisterDialog({ commit }) {
    commit("setAuthVolunteerRegisterDialog", false);
  },

  // Authentication entity register dialog
  showAuthEntityRegisterDialog({ commit }) {
    commit("setAuthEntityRegisterDialog", true);
  },
  hideAuthEntityRegisterDialog({ commit }) {
    commit("setAuthEntityRegisterDialog", false);
  },

  // Change password dialog
  showChangePasswordDialog({ commit }) {
    commit("setChangePasswordDialog", true);
  },
  hideChangePasswordDialog({ commit }) {
    commit("setChangePasswordDialog", false);
  },

  // Loader
  startLoading({ commit }) {
    commit("startLoading");
  },
  stopLoading({ commit }) {
    commit("stopLoading");
  }
};

// Mutations
const mutations = {
  // Authentication dialogs
  setAuthLoginDialog(state, status) {
    state.authLoginDialog = status;
  },
  setAuthVolunteerRegisterDialog(state, status) {
    state.authVolunteerRegisterDialog = status;
  },
  setAuthEntityRegisterDialog(state, status) {
    state.authEntityRegisterDialog = status;
  },

  setChangePasswordDialog(state, status) {
    state.changePasswordDialog = status;
  },

  // Loader
  startLoading(state) {
    state.loading = true;
  },
  stopLoading(state) {
    state.loading = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
